import { fromEvent, map, merge, Observable, shareReplay } from 'rxjs';

export enum ConnectionStatus {
  Offline,
  Online,
}

export class Connection {
  static get isOnline(): boolean {
    return navigator.onLine;
  }

  static get isOffline(): boolean {
    return !navigator.onLine;
  }

  static get connectionStatus$(): Observable<ConnectionStatus> {
    return merge(
      fromEvent(window, 'offline'),
      fromEvent(window, 'online')
    ).pipe(
      map(() =>
        Connection.isOnline ? ConnectionStatus.Online : ConnectionStatus.Offline
      ),
      shareReplay(1)
    );
  }
}
